import { useState, useEffect } from 'react'
import ReactGA from 'react-ga4'
import { useLocation } from 'react-router-dom'

import { appConfig } from '../config'

// TODO: add browser coverage for this when analytics is testable without production credentials.
export const useGoogleAnalytics = () => {
	const [isInitialized, setIsInitialized] = useState(false)
	const { search, pathname } = useLocation()
	const path = pathname + search

	useEffect(() => {
		if (!isInitialized && appConfig.wrappEnv === 'prod' && appConfig.googleAnalyticsTrackingId) {
			ReactGA.initialize(appConfig.googleAnalyticsTrackingId)
			setIsInitialized(true)
		}
	}, [isInitialized])

	useEffect(() => {
		if (isInitialized) {
			ReactGA.send({ hitType: 'pageview', page: path })
		}
	}, [path])
}
